"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamMember = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const layout_1 = require("../layout");
const avatar_1 = require("../avatar");
const featured_cell_1 = require("./featured_cell");
const TeamMember = ({ name, avatarUrl, }) => {
    return ((0, jsx_runtime_1.jsxs)(layout_1.Row, Object.assign({ alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(avatar_1.Avatar, { src: avatarUrl !== null && avatarUrl !== void 0 ? avatarUrl : '', displayName: name !== null && name !== void 0 ? name : 'No Pro Found', size: "small", marginRight: '20px' }), (0, jsx_runtime_1.jsx)(featured_cell_1.ListRowFeaturedCell, { headline: name !== null && name !== void 0 ? name : 'No Pro Found', subHeadline: '' })] })));
};
exports.TeamMember = TeamMember;
//# sourceMappingURL=team_member.js.map